import React, { Component }from 'react'
import { connect } from 'react-redux'

import { Table, Row, Col, Button, FormGroup, InputGroup, FormControl, Glyphicon } from 'react-bootstrap'

import ProjectDeliverable from './ProjectDeliverable'

import PaginationButtons from '../../../reuseable-components/PaginationButtons'

import { getDeliverablesWithFilters } from '../reducers/manageProjects'

import { changeDeliverablesPage, changeDeliverableSearchTerm, toggleDeliverablesHaveBeenSearched } from '../reducers/manageProjectFilters'


class DeliverableView extends Component {

  componentDidMount() {
    const searchBar = document.getElementById('deliverablesSearchTermInput')

    if (searchBar) {
      searchBar.addEventListener("search", this.handleSearchBarClear)
    }

    if (this.props.deliverableSearchTerm) {
      this.props.toggleDeliverablesHaveBeenSearched(true)
    } else {
      this.props.toggleDeliverablesHaveBeenSearched(false)
    }
  }


  componentWillUnmount() {
    const searchBar = document.getElementById('deliverablesSearchTermInput')

    if (searchBar) {
      searchBar.removeEventListener("search", this.handleSearchBarClear)
    }
  }


  handleSearchBarClear = (event) => {
    const { deliverablesHaveBeenSearched } = this.props
    if (event.type && event.type === 'search' && deliverablesHaveBeenSearched) {
      this.props.toggleDeliverablesHaveBeenSearched(false)
      this.props.handleGetDeliverables(1)
    }
  }

  handleSearch = () => {
    this.props.toggleDeliverablesHaveBeenSearched(true)
    this.props.handleGetDeliverables(1)
  }


  handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch()
    }
  }

  render () {

    const {
      fetchingDeliverables,
      deliverables,
      deliverableCount,
      deliverableResultsPerPage,
      currentDeliverablesPage,
     } = this.props

    let numberOfPages
    if (deliverables && deliverables.length > 0) {
      numberOfPages = Math.ceil(deliverableCount / deliverableResultsPerPage)
    }

    return (
      <div id="DeliverableView">


        <Row>

          <Col md={6}>
            <div style={{ marginTop: "15px" }}>
              <FormGroup>
                <InputGroup>
                  <FormControl
                    id='deliverablesSearchTermInput'
                    type="search"
                    value={this.props.deliverableSearchTerm}
                    placeholder="Search by deliverable or project"
                    onChange={(e) => this.props.changeDeliverableSearchTerm(e.target.value)}
                    onKeyDown={this.handleEnterPress}
                  />
                  <InputGroup.Button>
                    <Button
                      bsStyle={this.props.deliverableSearchTerm ? "info" : "default"}
                      onClick={this.handleSearch}
                    >
                      <Glyphicon glyph="search" />
                    </Button>
                  </InputGroup.Button>
                </InputGroup>
              </FormGroup>
            </div>
          </Col>

          <Col xs={6}>
            {numberOfPages && numberOfPages > 1 ?
              <center style={{fontSize:"8pt"}}>
                <PaginationButtons style={{ display: "inline-block" }}
                  numberOfPages={numberOfPages}
                  currentPage={currentDeliverablesPage}
                  buttonsPerPage={5}
                  onClick={this.props.handleGetDeliverables}
                />
              </center>
              :
              null
            }
          </Col>
        </Row>

        {!fetchingDeliverables && deliverables && deliverables.length === 0 ?
          <center>
            <br/>
            <h3>No Deliverables to display</h3>
          </center>
          :
          <Table>
            <thead>
              <tr>
                <td>Project</td>
                <td>Deliverable</td>
                <td>Status</td>
                <td>Due Date</td>
              </tr>
            </thead>
            <tbody style={{border:"solid thin #F5F6F6", overflow:"scroll", height:"50%"}}>
              {deliverables.map(deliverable => {
                return (
                  <ProjectDeliverable
                    history={this.props.history}
                    key={deliverable.id}
                    deliverable={deliverable}
                  />
                )
              })}
            </tbody>
          </Table>
        }

          {numberOfPages && numberOfPages > 1 ?
            <center style={{fontSize:"8pt"}}>
              <PaginationButtons style={{ display: "inline-block" }}
                numberOfPages={numberOfPages}
                currentPage={currentDeliverablesPage}
                buttonsPerPage={5}
                onClick={this.props.handleGetDeliverables}
              />
            </center>
            :
            null
          }

      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    deliverables: state.manageProjects.deliverables,
    deliverableCount: state.manageProjects.deliverableCount,
    deliverableResultsPerPage: state.manageProjects.deliverableResultsPerPage,
    fetchingDeliverables: state.manageProjects.fetchingDeliverables,


    projectLeadFilter: state.manageProjectFilters.projectLeads,
    analystFilter: state.manageProjectFilters.analysts,
    statusFilter: state.manageProjectFilters.status,
    metadataFilters: state.manageProjectFilters.metadataFilters,
    currentDeliverablesPage: state.manageProjectFilters.currentDeliverablesPage,

    projectSortType: state.manageProjectFilters.projectSortType,
    clientFilter: state.manageProjectFilters.clients,
    myDeliverablesFilter: state.manageProjectFilters.myDeliverablesFilter,
    deliverableStatusFilter: state.manageProjectFilters.deliverableStatusFilter,
    deliverableAssignedToFilter: state.manageProjectFilters.deliverableAssignedToFilter,
    deliverableSearchTerm: state.manageProjectFilters.deliverableSearchTerm,
    deliverableSortType: state.manageProjectFilters.deliverableSortType,

    deliverablesHaveBeenSearched: state.manageProjectFilters.deliverablesHaveBeenSearched,

    // currentUser: state.manageLogin.user,
    // clients: state.manageLogin.clients,
    // users: state.manageLogin.users,
  }
}

export default connect(mapStateToProps, { getDeliverablesWithFilters, changeDeliverablesPage, changeDeliverableSearchTerm, toggleDeliverablesHaveBeenSearched })(DeliverableView)



// WEBPACK FOOTER //
// ./src/routes/projects/components/DeliverableView.js